import { createSelector } from 'reselect'
import { hasPermission, PermissionLevels } from 'utils/permission'

export const getPermissionLevel = (state, props) => {
  return state['view-myboard'].view.permissionLevel
}

export const makePermissionSelector = () => createSelector(
  [getPermissionLevel],
  (permissionLevel) => {
    return {
      visitor: hasPermission(permissionLevel, PermissionLevels.VISITOR),
      member: hasPermission(permissionLevel, PermissionLevels.MEMBER),
      owner: hasPermission(permissionLevel, PermissionLevels.OWNER)
    }
  }
)

export const permissionSelector = makePermissionSelector()
